import { IApplicationState } from '../../../../../../../types/types';
import { IChatGroup } from '../../../../../../../rest/effects/chats/group/types';

export const getChatGroups = (state: IApplicationState): IChatGroup[] => {
    return state.chatView?.groups && Object.values(state.chatView.groups);
}
